"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDAOLogicV1__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "NewVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreatedWithRequirements",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ProposalQueued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProposalThresholdBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "ProposalThresholdBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalVetoed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldQuorumVotesBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "QuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingDelay",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "VotingDelaySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "VotingPeriodSet",
        type: "event",
    },
    {
        inputs: [],
        name: "BALLOT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_acceptAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_burnVetoPower",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "_setPendingAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "_setProposalThresholdBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "_setQuorumVotesBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "_setVetoer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "_setVotingDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "_setVotingPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "cancel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "castVoteBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "getActions",
        outputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
        ],
        name: "getReceipt",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "uint8",
                        name: "support",
                        type: "uint8",
                    },
                    {
                        internalType: "uint96",
                        name: "votes",
                        type: "uint96",
                    },
                ],
                internalType: "struct NounsDAOStorageV1.Receipt",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "timelock_",
                type: "address",
            },
            {
                internalType: "address",
                name: "nouns_",
                type: "address",
            },
            {
                internalType: "address",
                name: "vetoer_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "votingPeriod_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "votingDelay_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "proposalThresholdBPS_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotesBPS_",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nouns",
        outputs: [
            {
                internalType: "contract NounsTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalMaxOperations",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThresholdBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "forVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "abstainVotes",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "canceled",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "vetoed",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "propose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "queue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotesBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "state",
        outputs: [
            {
                internalType: "enum NounsDAOStorageV1.ProposalState",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract INounsDAOExecutor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "veto",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsDAOLogicV1__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDAOLogicV1__factory = NounsDAOLogicV1__factory;
NounsDAOLogicV1__factory.bytecode = _bytecode;
NounsDAOLogicV1__factory.abi = _abi;
